/**
 * Removes a marker from a Google Map instance.
 */
export const removeMarker = ({ marker, maps, }) => {
    if (marker) {
        marker.setMap(null);
        maps?.event.clearInstanceListeners(marker);
    }
};
